import React from 'react';
import Administration from '../components/administration/administration';

export default function AdministrationPage() {
    return (
        <>
            <Administration/>
        </>
    )
}
